import type { Messages } from '@ah/i18n';

/** Greek — primary/default locale (ADR-015). Source of truth: a missing `en` key falls back here. */
export const el: Messages = {
  auth: {
    login: {
      title: 'Σύνδεση θεραπευτή',
      email: 'Email',
      password: 'Κωδικός',
      submit: 'Σύνδεση',
      submitting: 'Σύνδεση…',
      missingFields: 'Παρακαλούμε συμπλήρωσε email και κωδικό.',
      resendPrompt: 'Δεν βρίσκεις το email επιβεβαίωσης; Μπορούμε να το ξαναστείλουμε.',
      resendButton: 'Στείλε ξανά το email',
      resendSent: 'Αν υπάρχει λογαριασμός με αυτό το email, στάλθηκε νέος σύνδεσμος. Δες και τον φάκελο ανεπιθύμητων.',
      resendFailed: 'Κάτι πήγε στραβά. Δοκίμασε ξανά σε λίγο.',
      wrongPortal: 'Αυτή η πύλη είναι μόνο για θεραπευτές. Συνδέσου με λογαριασμό θεραπευτή.',
      failed: 'Η σύνδεση απέτυχε. Δοκίμασε ξανά.',
      noAccount: 'Νέος/α θεραπευτής στο Anonymous Help;',
      registerLink: 'Εγγραφή',
    },
    twoFactor: {
      prompt: 'Βάλε τον εξαψήφιο κωδικό από την εφαρμογή authenticator ή από το email σου.',
      codeLabel: 'Κωδικός',
      submit: 'Επιβεβαίωση',
      failed: 'Λάθος κωδικός. Δοκίμασε ξανά.',
      recoveryHint: 'Αν δεν έχεις πρόσβαση, μπορείς να βάλεις έναν εφεδρικό κωδικό (π.χ. ABCDE-12345).',
    },
    register: {
      title: 'Εγγραφή ως θεραπευτής',
      intro: 'Ο λογαριασμός σου ελέγχεται πριν αντιστοιχιστείς με πελάτες — μπορείς να συνδεθείς και να εξερευνήσεις την πύλη στο μεταξύ.',
      email: 'Email',
      password: 'Κωδικός (min 10 χαρακτήρες, κεφαλαία/πεζά + αριθμός)',
      displayName: 'Όνομα εμφάνισης',
      displayNamePlaceholder: 'π.χ. Δρ. Μαρία Παπαδοπούλου',
      licenseNumber: 'Αριθμός άδειας',
      licenseCountry: 'Χώρα άδειας (κωδικός 2 γραμμάτων)',
      professionalType: 'Ιδιότητα',
      typePsychologist: 'Ψυχολόγος με άδεια ασκήσεως επαγγέλματος',
      typeCounselor: 'Σύμβουλος / Coach',
      professionalTypeHint: 'Η ιδιότητα επιβεβαιώνεται από την ομάδα μας πριν την έγκριση. Στην αρχική σελίδα οι ψυχολόγοι και οι σύμβουλοι εμφανίζονται ξεχωριστά.',
      specialties: 'Ειδικότητες (χωρισμένες με κόμμα)',
      specialtiesPlaceholder: 'π.χ. άγχος, τραύμα, σχέσεις',
      specialtiesError: 'Γράψε τουλάχιστον μία ειδικότητα, χωρισμένες με κόμμα.',
      failed: 'Η εγγραφή απέτυχε. Δοκίμασε ξανά.',
      legalNoticePrefix: 'Με την εγγραφή σου αποδέχεσαι τους',
      legalNoticeJoiner: 'και την',
      termsLink: 'Όρους Χρήσης',
      privacyLink: 'Πολιτική Απορρήτου',
      alreadyRegistered: 'Έχεις ήδη λογαριασμό;',
      loginLink: 'Σύνδεση',
      submit: 'Δημιουργία λογαριασμού θεραπευτή',
      submitting: 'Δημιουργία λογαριασμού…',
    },
  },
  verifyEmail: {
    title: 'Επιβεβαίωση email',
    success: 'Το email σου επιβεβαιώθηκε. Μπορείς να συνδεθείς.',
    already: 'Αυτό το email είχε ήδη επιβεβαιωθεί. Μπορείς να συνδεθείς κανονικά.',
    noToken: 'Ο σύνδεσμος είναι ελλιπής. Άνοιξέ τον απευθείας από το email.',
    failed: 'Δεν μπορέσαμε να επιβεβαιώσουμε το email.',
    failedHint: 'Ζήτησε νέο σύνδεσμο από τη σελίδα σύνδεσης.',
    goToLogin: 'Στη σύνδεση',
  },
  dashboard: {
    title: 'Πύλη θεραπευτή',
    myProfile: 'Το προφίλ μου',
    myServices: 'Υπηρεσίες & τιμές',
    payouts: 'Πληρωμές',
    settings: 'Ρυθμίσεις',
    signOut: 'Αποσύνδεση',
    pendingReview: 'Ο λογαριασμός σου βρίσκεται υπό έλεγχο — μπορείς να εξερευνήσεις την πύλη τώρα, αλλά δεν θα αντιστοιχιστείς με πελάτες μέχρι να εγκριθεί από διαχειριστή.',
    suspended: 'Ο λογαριασμός σου έχει ανασταλεί. Επικοινώνησε με έναν διαχειριστή για λεπτομέρειες.',
    rejected: 'Η αίτησή σου δεν εγκρίθηκε. Επικοινώνησε με έναν διαχειριστή για λεπτομέρειες.',
    loading: 'Φόρτωση…',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των κρατήσεών σου.',
    yourBookings: 'Οι κρατήσεις σου',
    noBookings: 'Δεν υπάρχουν κρατήσεις ακόμα.',
    working: 'Επεξεργασία…',
    accept: 'Αποδοχή',
    decline: 'Απόρριψη',
    declinePrompt: 'Αιτιολογία απόρριψης (προαιρετικό):',
    acceptError: 'Δεν ήταν δυνατή η αποδοχή της κράτησης. Δοκίμασε ξανά.',
    declineError: 'Δεν ήταν δυνατή η απόρριψη της κράτησης. Δοκίμασε ξανά.',
    awaitingPayment: 'Αναμονή πληρωμής πελάτη.',
    openCall: 'Έναρξη κλήσης',
  },
  payouts: {
    title: 'Πληρωμές',
    backDashboard: '← Πίνακας',
    connectStatusTitle: 'Κατάσταση Stripe Connect',
    onboarded: '✅ Οι πληρωμές έχουν ρυθμιστεί — θα λαμβάνεις το 90% κάθε κράτησης, με εβδομαδιαία εκκαθάριση.',
    notFullySetUp: 'Ο λογαριασμός σου Stripe δεν έχει ολοκληρωθεί ακόμα — ολοκλήρωσε την εγγραφή για να λαμβάνεις πληρωμές.',
    notConnected: 'Δεν έχεις συνδέσει ακόμα λογαριασμό πληρωμών.',
    completeOnboarding: 'Ολοκλήρωση εγγραφής Stripe',
    redirecting: 'Μεταφορά…',
    onboardingError: 'Δεν ήταν δυνατή η έναρξη της εγγραφής.',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των στοιχείων πληρωμών.',
    payoutHistory: 'Ιστορικό πληρωμών',
    noPayouts: 'Δεν υπάρχουν πληρωμές ακόμα.',
    bookingsSuffix: 'κράτηση/εις',
    net: 'καθαρό',
  },
  settings: {
    title: 'Ρυθμίσεις λογαριασμού',
    backDashboard: '← Πίνακας',
    language: 'Γλώσσα',
    deleteAccount: 'Διαγραφή λογαριασμού',
    scheduledFor: 'Ο λογαριασμός σου έχει προγραμματιστεί για διαγραφή στις {{date}}. Μπορείς να το ακυρώσεις οποιαδήποτε στιγμή πριν από τότε.',
    cancelling: 'Ακύρωση…',
    cancelRequest: 'Ακύρωση αιτήματος διαγραφής',
    graceNotice: 'Αυτό ξεκινά μια περίοδο χάριτος {{days}} ημερών κατά την οποία μπορείς να ακυρώσεις. Μετά από αυτό, το δημόσιο προφίλ, τα μηνύματα και τα στοιχεία σύνδεσής σου ανωνυμοποιούνται μόνιμα. Βεβαιώσου ότι δεν έχεις επερχόμενες κρατήσεις και έχεις επικοινωνήσει με την υποστήριξη για τυχόν εκκρεμή πληρωμή πρώτα — τα αρχεία κρατήσεων και τιμολογίων διατηρούνται όπως απαιτείται από τη φορολογική νομοθεσία, αποσυνδεδεμένα από την ταυτότητά σου. Εισήγαγε τον κωδικό σου για επιβεβαίωση.',
    password: 'Κωδικός',
    submitting: 'Υποβολή…',
    confirmDeletion: 'Επιβεβαίωση διαγραφής',
    cancel: 'Ακύρωση',
    deleteMyAccount: 'Διαγραφή λογαριασμού μου',
    deletionRequestError: 'Δεν ήταν δυνατή η υποβολή του αιτήματος διαγραφής.',
    deletionCancelError: 'Δεν ήταν δυνατή η ακύρωση του αιτήματος διαγραφής.',
  },
  profile: {
    title: 'Το προφίλ μου',
    backDashboard: '← Πίνακας',
    intro: 'Αυτό βλέπουν οι πελάτες στην αρχική σελίδα: φωτογραφία, τίτλο, βιογραφικό, βίντεο παρουσίασης, ειδικότητες και τα περιστατικά που αναλαμβάνεις.',
    loading: 'Φόρτωση…',
    loadError: 'Δεν ήταν δυνατή η φόρτωση του προφίλ σου.',
    photo: 'Φωτογραφία προφίλ',
    photoUpdated: 'Η φωτογραφία ενημερώθηκε.',
    photoUploadFailed: 'Το ανέβασμα απέτυχε.',
    tabEl: 'Ελληνικά',
    tabEn: 'English',
    requiredBadge: 'υποχρεωτικό',
    optionalBadge: 'προαιρετικό',
    completeBadge: '✓ πλήρες',
    incompleteBadge: 'ελλιπές',
    headlineLabel: 'Τίτλος (π.χ. «Κλινική Ψυχολόγος, 12 χρόνια εμπειρίας»)',
    bioLabel: 'Βιογραφικό / περιγραφή',
    introVideoLabel: 'Βίντεο παρουσίασης (σύνδεσμος YouTube/Vimeo — προαιρετικό, κοινό και για τις δύο γλώσσες)',
    categoriesLegend: 'Κατηγορίες (ειδικότητες — επίλεξε από τη λίστα, κοινές και για τις δύο γλώσσες)',
    caseTagsLabel: 'Περιστατικά που αναλαμβάνω (tags, χωρισμένα με κόμμα)',
    caseTagsPlaceholderEl: 'π.χ. κρίσεις πανικού, πένθος, burnout',
    caseTagsPlaceholderEn: 'e.g. panic attacks, grief, burnout',
    spokenLanguagesLegend: 'Γλώσσες συνεδρίας (σε ποιες γλώσσες μπορείς να κάνεις τη συνεδρία)',
    save: 'Αποθήκευση προφίλ',
    saving: 'Αποθήκευση…',
    saveSuccess: 'Το προφίλ αποθηκεύτηκε — φαίνεται άμεσα στην αρχική σελίδα (εφόσον είσαι εγκεκριμένος).',
    saveFailed: 'Η αποθήκευση απέτυχε.',
  },
  call: {
    connecting: 'Σύνδεση…',
    waitingForOther: 'Αναμονή για τον πελάτη…',
    ending: 'Τερματισμός κλήσης…',
    ended: 'Η κλήση τερμάτισε — {{duration}}',
    anonymousNotice: 'Ανώνυμη κλήση — η φωνή σου είναι αλλοιωμένη, η κάμερα είναι απενεργοποιημένη.',
    mute: 'Σίγαση',
    unmute: 'Άρση σίγασης',
    endCall: 'Τερματισμός κλήσης',
    done: 'Τέλος',
    back: 'Πίσω',
    genericError: 'Κάτι πήγε στραβά.',
    needSignIn: 'Χρειάζεται να συνδεθείς για να μπεις σε αυτή την κλήση.',
    joinError: 'Δεν ήταν δυνατή η σύνδεση στην κλήση.',
  },
  services: {
    backDashboard: '← Πίνακας',
    title: 'Υπηρεσίες & τιμές',
    intro: 'Όρισε τι προσφέρεις και πόσο κοστίζει. Μπορείς να έχεις όσες υπηρεσίες θέλεις — π.χ. ψυχοθεραπεία 50€ και coaching 80€. Ο πελάτης βλέπει ακριβώς ό,τι είναι ενεργό εδώ.',
    noneActive: 'Δεν έχεις καμία ενεργή υπηρεσία, οπότε κανείς δεν μπορεί να κλείσει συνεδρία μαζί σου — όσο πλήρες κι αν είναι το προφίλ σου.',
    empty: 'Δεν έχεις προσθέσει ακόμα υπηρεσίες.',
    priceLabel: 'Τιμή',
    clientPays: 'Ο πελάτης πληρώνει {{amount}}',
    savePrice: 'Αποθήκευση τιμής',
    hide: 'Απόκρυψη',
    show: 'Εμφάνιση',
    remove: 'Διαγραφή',
    visible: 'Ορατή',
    hidden: 'Κρυφή',
    addTitle: 'Πρόσθεσε υπηρεσία',
    choosePlaceholder: 'Διάλεξε υπηρεσία…',
    pricePlaceholder: 'π.χ. 50',
    add: 'Προσθήκη',
    allAdded: 'Έχεις ήδη προσθέσει όλες τις διαθέσιμες υπηρεσίες.',
    saved: 'Αποθηκεύτηκε.',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των υπηρεσιών.',
    saveError: 'Η αποθήκευση απέτυχε. Έλεγξε την τιμή και δοκίμασε ξανά.',
    confirmRemove: 'Να διαγραφεί η υπηρεσία «{{name}}»; Οι ολοκληρωμένες συνεδρίες δεν επηρεάζονται.',
  },
  common: {
    loading: 'Φόρτωση…',
    cancel: 'Άκυρο',
  },
  twoFactor: {
    title: 'Επιβεβαίωση σε δύο βήματα',
    intro: 'Ένα δεύτερο βήμα στη σύνδεση, ώστε μόνο ο κωδικός σου να μην αρκεί για να μπει κάποιος στον λογαριασμό σου.',
    off: 'Αυτή τη στιγμή είναι απενεργοποιημένη.',
    onTotp: 'Ενεργή — μέσω εφαρμογής authenticator.',
    onEmail: 'Ενεργή — με κωδικό στο email σου.',
    turnOn: 'Ενεργοποίηση',
    turnOff: 'Απενεργοποίηση',
    totpTitle: 'Εφαρμογή authenticator',
    totpBody: 'Πιο ασφαλές. Χρειάζεσαι μια εφαρμογή όπως το Google Authenticator στο κινητό σου.',
    chooseTotp: 'Χρήση εφαρμογής',
    emailTitle: 'Κωδικός στο email',
    emailBody: 'Πιο απλό. Σου στέλνουμε εξαψήφιο κωδικό σε κάθε σύνδεση. Δεν χρειάζεσαι καμία εφαρμογή.',
    chooseEmail: 'Χρήση email',
    scanHint: 'Σκάναρε τον κωδικό QR με την εφαρμογή σου και μετά γράψε τον εξαψήφιο κωδικό που εμφανίζεται.',
    qrAlt: 'Κωδικός QR για την εφαρμογή authenticator',
    manualKey: 'Ή γράψε το κλειδί χειροκίνητα',
    emailSent: 'Στείλαμε έναν εξαψήφιο κωδικό στο {{email}}.',
    resend: 'Στείλε ξανά',
    resent: 'Στάλθηκε νέος κωδικός στο {{email}}.',
    codeLabel: 'Κωδικός',
    confirm: 'Επιβεβαίωση',
    recoveryTitle: 'Εφεδρικοί κωδικοί',
    recoveryBody: 'Κράτησέ τους κάπου ασφαλή. Εμφανίζονται μόνο τώρα και δεν μπορούμε να στους ξαναδείξουμε. Χωρίς αυτούς, αν χάσεις το κινητό ή το email σου, χάνεις τον λογαριασμό.',
    savedThem: 'Τους αποθήκευσα',
    disableHint: 'Για ασφάλεια, χρειάζεται και ο κωδικός πρόσβασής σου και ένας τρέχων κωδικός δύο βημάτων.',
    passwordLabel: 'Κωδικός πρόσβασης',
    disabled: 'Η επιβεβαίωση δύο βημάτων απενεργοποιήθηκε.',
    genericError: 'Κάτι πήγε στραβά. Δοκίμασε ξανά.',
  },
};
